<template>
  <div>
    <vue-toastr ref="notificationToast"></vue-toastr>
    <div class="ibox box-primary">
      <div class="ibox-title with-border"><h3 class="box-title">Sicherheit</h3></div>
      <div class="ibox-content">
        <p>Die Zwei-Faktor-Authentifizierung fügt Ihrem Konto eine zusätzliche
          Sicherheitsebene hinzu, indem mehr als nur ein Passwort zur Anmeldung verlangt wird.</p> <br> <b>Zwei-Faktor-Authentifizierung</b>
        <p>
          Status:
          <span class="badge badge-primary" v-if="activated">Aktiviert</span>
          <span class="badge badge-danger" v-if="!activated">Deaktiviert</span>
        </p>
      </div>
      <div class="ibox-footer">
        <button class="btn btn-primary" data-toggle="modal" data-target="#qr-modal" v-if="!activated">Aktivieren
        </button>
        <button class="btn btn-danger" data-toggle="modal" data-target="#qr-modal-disable" v-if="activated">
          Deaktivieren
        </button>
      </div>
    </div>
    <two-factor-auth-enable-modal v-on:success="success"></two-factor-auth-enable-modal>
    <two-factor-auth-disable-modal v-on:success="success"></two-factor-auth-disable-modal>
  </div>
</template>

<script>
import VueToastr from "vue-toastr";
import {mapGetters, mapMutations} from "vuex";
import TwoFactorAuthEnableModal from "./Modals/TwoFactorAuthEnableModal";
import TwoFactorAuthDisableModal from "./Modals/TwoFactorAuthDisableModal";

export default {
  name: 'TwoFactorAuth',
  data() {
    return {}
  },
  components: {TwoFactorAuthDisableModal, TwoFactorAuthEnableModal, VueToastr},
  props: ['user', 'secret', 'qrCode'],
  mounted() {
    let activated = false;
    if (this.user.two_factor_secret) {
      activated = true;
    }

    this.setState({
      activated: activated,
      qrCode: this.qrCode,
      secret: this.secret
    })
  },
  methods: {
    ...mapMutations([
      'setState'
    ]),
    success(status) {
      if (status === 'enable') {
        this.$refs.notificationToast.s('Zwei-Faktor-Authentifizierung wurde aktiviert');
      } else {
        this.$refs.notificationToast.s('Zwei-Faktor-Authentifizierung wurde deaktiviert');
      }
    }
  },
  computed: {
    ...mapGetters({
      activated: 'getActivated'
    })
  }
}
</script>

<style scoped>
</style>
